import { Card, CardActionArea, CardMedia, CardContent, Typography, Skeleton } from "@mui/material";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CardComponent = (props) => {
    const { data } = props;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const handleClick = () => {
        navigate(`${data?.path}`);
    };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    return (
        <Card sx={{ width: 330, borderRadius: 2 }}>
            <CardActionArea onClick={handleClick}>
                {loading ? (
                    <Skeleton variant="rectangular" width={330} height={150} />
                ) : (
                    <CardMedia
                        component="img"
                        height="150"
                        image={data?.image}
                        alt="example"
                        loading="lazy"
                        sx={{ objectFit: "cover" }}
                    />
                )}
                <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2, py: 2 }}>
                    <Typography variant="subtitle1" fontWeight={600} color="#878787">
                        {data?.title}
                    </Typography>
                    <ArrowCircleRightIcon sx={{ color: "#878787" }} />
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default CardComponent;
